


















import Vue from "vue";
import { Title, Button } from "@apphq/vue-base-components";
import { capitalize, titlecase } from "@apphq/utils";
import I18NextMixin from "./i18n/I18NextMixin";

export default Vue.extend({
  components: {
    RButton: Button,
    RTitle: Title
  },
  filters: {
    capitalize,
    titlecase
  },
  mixins: [I18NextMixin]
});
